module.exports = __webpack_public_path__ + "static/media/post-office.bd5fea0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/post-office.png
// module id = 586
// module chunks = 0